<template>
  <div>
    <DataTable :headers="headers" :path="path" actionButtonsName="LiquidacionActionButtons" :properties="properties" filter
               toolbar toolbar-title="Liquidaciones LPF" search-text="Buscar por título u observación" :filter-path="filterPath"></DataTable>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newLiquidacion">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

const CLUB_INDEX_IN_TABLE = 3

export default {
  components: {
    DataTable
  },

  data () {
    return {
      path: 'settlements',
      filterPath: 'filters/settlements'
    }
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddLiquidacionestv
    },
    headers () {
      let headers = [
        { text: 'Fecha', value: 'fecha', align: 'left' },
        { text: 'Período', value: 'period', align: 'left' },
        { text: 'Tipo', value: 'settlement_type', align: 'left' },
        { text: 'Título', value: 'title', align: 'left' },
        { text: 'Observación', sortable: false, value: 'description', align: 'left' },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(CLUB_INDEX_IN_TABLE, 0, { text: 'Club', value: 'club', sortable: false, filterField: true })
      }
      return headers
    },
    properties () {
      let properties = ['fecha', 'period', 'settlementType', 'title', 'description']
      if (this.$store.getters.isSafRole) {
        properties.splice(CLUB_INDEX_IN_TABLE, 0, 'club')
      }
      return properties
    }
  },

  methods: {
    newLiquidacion () {
      this.$router.push({ name: 'nuevaLiquidacion' })
    }
  }
}
</script>
